export const getCompanies = (state) => state.companies.all
